export default "__VITE_ASSET__CEF65Wef__"